import { render, staticRenderFns } from "./ContainerSingleExercise.vue?vue&type=template&id=3fd7b898&scoped=true"
import script from "./ContainerSingleExercise.vue?vue&type=script&lang=js"
export * from "./ContainerSingleExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd7b898",
  null
  
)

export default component.exports